import { render, staticRenderFns } from "./ProductPricing.vue?vue&type=template&id=6d2d5540"
import script from "./ProductPricing.vue?vue&type=script&lang=js"
export * from "./ProductPricing.vue?vue&type=script&lang=js"
import style0 from "./ProductPricing.vue?vue&type=style&index=0&id=6d2d5540&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports